import { api } from "./httpClient";

async function dataUrlToBlob(dataUrl) {
  const response = await fetch(dataUrl);
  return response.blob();
}

export const bookingService = {
  getAvailability(checkIn, checkOut, agentUsername, tenantId) {
    const params = new URLSearchParams({ checkIn, checkOut });
    if (agentUsername) params.set("agentUsername", agentUsername);
    if (tenantId) params.set("tenantId", tenantId);
    return api(`/availability?${params}`);
  },
  getReport(filters, allowedPropertyIds) {
    const { propertyId, ...reportFilters } = filters;
    const params = new URLSearchParams(Object.entries(reportFilters).filter(([, value]) => value));
    if (propertyId) params.set("propertyId", propertyId);
    if (allowedPropertyIds) {
      params.set("propertyIds", allowedPropertyIds.length ? allowedPropertyIds.join(",") : "-1");
    }
    return api(`/bookings?${params}`);
  },
  getReportWithTenant(filters, tenantId) {
    const params = new URLSearchParams(Object.entries(filters).filter(([, value]) => value));
    if (tenantId) params.set("tenantId", tenantId);
    return api(`/bookings?${params}`);
  },
  saveBooking(payload) {
    return api("/bookings", {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
  async getGuests(bookingId) {
    const pageSize = 100;
    const guests = [];
    let page = 0;

    while (true) {
      const params = new URLSearchParams({ bookingId, page: String(page), size: String(pageSize), sort: "id,asc" });
      const result = await api(`/v1/booking-guests?${params}`);
      if (!result || !Array.isArray(result.content)) {
        throw new Error("The guest list response was invalid.");
      }

      guests.push(...result.content);
      if (page + 1 >= Number(result.totalPages || 0)) return guests;
      page += 1;
    }
  },
  async createGuest({ bookingId, guestType = "ADDITIONAL", name, mobile, idType, idNumber, attachment, attachmentName }) {
    const params = new URLSearchParams({ bookingId, guestType, name });
    if (mobile) params.set("mobile", mobile);
    if (idType) params.set("idType", idType);
    if (idNumber) params.set("idNumber", idNumber);

    const formData = new FormData();
    const proof = attachment ? await dataUrlToBlob(attachment) : new Blob([]);
    const filename = attachmentName || "guest-id-proof";
    formData.append("image", proof, filename);
    if (proof.type === "application/pdf") formData.append("attachment", proof, filename);

    return api(`/v1/booking-guests?${params.toString()}`, {
      method: "POST",
      body: formData,
    });
  },
  getDashboard() {
    return api("/dashboard");
  },
};
